import AgentAdminApi from './AgentAdminApi';
export default AgentAdminApi;
